<template >
  <div>
    <van-radio-group v-model="orderStatus" @change="radioChange">
      <van-cell-group>
        <van-cell :title="generateCustomizeString('未付款')">
          <van-radio :name="0" :disabled="this.checkUnpiadEnable()" />
        </van-cell>
        <van-cell :title="generateCustomizeString('部分付款')">
          <van-radio :name="5" disabled />
        </van-cell>
        <van-cell :title="generateCustomizeString('已付款（待发货）')">
          <van-radio :name="10" :disabled="this.checkPiadEnable()" />
        </van-cell>
        <van-cell :title="generateCustomizeString('配货中')" v-if="this.orderDetailData.is_pick_up === 0">
          <van-radio :name="15" :disabled="this.checkPickingEnable()" />
        </van-cell>
        <van-cell :title="generateCustomizeString('已发货（待完成）')" v-if="this.orderDetailData.is_pick_up === 0">
          <van-radio :name="20" :disabled="this.checkShippedEnable()" />
        </van-cell>
        <van-cell :title="generateCustomizeString('交易完成')">
          <van-radio :name="40" disabled />
        </van-cell>
        <van-cell :title="generateCustomizeString('申请退款')">
          <van-radio :name="50" disabled />
        </van-cell>
        <van-cell :title="generateCustomizeString('退款完成')">
          <van-radio :name="60" :disabled="this.checkRefundCompletedEnable()" />
        </van-cell>
        <van-cell :title="generateCustomizeString('cancelRefund')">
          <van-radio :name="51" :disabled="this.checkCancelRefundEnable()" />
        </van-cell>
        <van-cell :title="generateCustomizeString('已关闭')">
          <van-radio :name="97" :disabled="this.checkCloseEnable()" />
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div style="margin-top: 5px; background-color: #fff;" v-show="this.checkIsRefundShow()">
      <van-cell-group>
        <van-cell :title="generateCustomizeString('refundType')" style="font-weight: 500;">
        </van-cell>
        <van-radio-group v-model="refundType">
          <van-cell-group>
            <van-cell :title="generateCustomizeString('refundToCredit')">
              <van-radio name="1" />
            </van-cell>
            <van-cell :title="generateCustomizeString('refundToOPM')">
              <van-radio name="2" />
            </van-cell>
            <van-cell :title="generateCustomizeString('refundToOffline')">
              <van-radio name="3" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-cell-group>
      <div class="polipay-refund2OPM-alert" v-if="this.refundType == '2' && this.poliPaidTransaction">
        *订单有POLi支付的部分，请在平台提交原路退款后，线下转账给用户POLi支付的金额 {{ this.poliPaidTransaction['fee'] / 100}} NZD
      </div>
      <!-- <van-checkbox v-model="isRefund">{{generateCustomizeString('refundToCredit')}}</van-checkbox> -->
    </div>
    <div style="margin-top: 5px; margin-bottom: 5px;">
      <van-field v-model="operationNotes" :label="generateCustomizeString('operationNotes')" :placeholder="generateCustomizeString('pleaseInput')" type="textarea" rows="1" autosize />
    </div>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, Button, Cell, CellGroup, RadioGroup, Radio, Checkbox, Dialog, Field, Toast } from 'vant'
// import request from '@/utils/request'

export default {
  name: 'OrderStatus',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  data() {
    return {
      status: 0,
      orderStatus: 0,
      orderStatusCopy: null,
      isRefund: false,
      operationNotes: '',
      refundType: '1' // 默认退回余额
    }
  },
  props: {
    orderStatusProps: {
      type: Number,
      default: null
    },
    orderDetailData: {
      type: Object,
      default: () => ({})
    },
    poliPaidTransaction: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    generateCustomizeString,
    checkUnpiadEnable: function() {
      if (this.status >= 90 && this.status !== 99) {
        return false
      } else {
        return true
      }
    },
    checkPiadEnable: function() {
      if (this.status === 0 || this.status === 5) {
        return false
      } else {
        return true
      }
    },
    checkPickingEnable: function() {
      if (this.status === 10) {
        return false
      } else {
        return true
      }
    },
    checkShippedEnable: function() {
      if (this.status === 10 || this.status === 15) {
        return false
      } else {
        return true
      }
    },
    checkRefundCompletedEnable: function() {
      if (this.status === 50) {
        return false
      } else {
        return true
      }
    },
    checkCancelRefundEnable: function() {
      if (this.status === 50) {
        return false
      } else {
        return true
      }
    },
    checkCloseEnable: function() {
      if (this.status === 20 || this.status === 40 || this.status === 50) {
        return true
      } else {
        return false
      }
    },
    checkIsRefundShow: function() {
      const flag1 = this.status === 5 || this.status === 10 || this.status === 15
      const flag2 = this.orderStatus === 97
      const flag3 = this.status === 50
      const flag4 = this.orderStatus === 60
      if ((flag1 && flag2) || (flag3 && flag4)) {
        return true
      } else {
        return false
      }
    },
    radioChange() {
      this.orderStatusCopy = this.orderStatus
    }
  },
  created: function() {
    this.status = this.orderStatusProps
    if (this.orderStatusProps >= 90) {
      this.orderStatus = 97
    } else {
      this.orderStatus = this.orderStatusProps
    }
  }
}
</script>

<style type="text/css">
  .van-field__control {
    line-height: 24px !important;
  }
</style>
<style lang="less" scoped>
  .polipay-refund2OPM-alert {
    padding: 15px;
    color: red;
    line-height: 20px;
  }
</style>
